export default [
  { label: 'Select a company...', value: '' },
  { label: '1st Company', value: '1st Company' },
  { label: '2nd Company', value: '2nd Company' },
  { label: '3rd Company', value: '3rd Company' },
  { label: '4th Company', value: '4th Company' },
  { label: '5th Company', value: '5th Company' },
  { label: '6th Company', value: '6th Company' },
  { label: '7th Company', value: '7th Company' },
  { label: '8th Company', value: '8th Company' },
  { label: '9th Company', value: '9th Company' },
  { label: '10th Company', value: '10th Company' },
  { label: '11th Company', value: '11th Company' },
  { label: '12th Company', value: '12th Company' },
  { label: '13th Company', value: '13th Company' },
  { label: '14th Company', value: '14th Company' },
  { label: '15th Company', value: '15th Company' },
  { label: '16th Company', value: '16th Company' },
  { label: '17th Company', value: '17th Company' },
  { label: '18th Company', value: '18th Company' },
  { label: '19th Company', value: '19th Company' },
  { label: '20th Company', value: '20th Company' },
  { label: '21st Company', value: '21st Company' },
  { label: '22nd Company', value: '22nd Company' },
  { label: '23rd Company', value: '23rd Company' },
  { label: '24th Company', value: '24th Company' },
  { label: '25th Company', value: '25th Company' },
  { label: '26th Company', value: '26th Company' },
  { label: '27th Company', value: '27th Company' },
  { label: '28th Company', value: '28th Company' },
  { label: '29th Company', value: '29th Company' },
  { label: '30th Company', value: '30th Company' },
  { label: '31st Company', value: '31st Company' },
  { label: '32nd Company', value: '32nd Company' },
  { label: '33rd Company', value: '33rd Company' },
  { label: '34th Company', value: '34th Company' },
  { label: '35th Company', value: '35th Company' },
  { label: '36th Company', value: '36th Company' }
]
